import "./style/index.scss";

export default {
  inheritAttrs: false,
  name: "WPageTitle",
  __WF_: true,
  data() {
    return {
      prefixCls: "wf-page-title"
    };
  },
  render() {
    const { prefixCls, $slots } = this;

    return (
      <div class={prefixCls}>
        <div class={`${prefixCls}-content`}>{$slots.default}</div>
        <div class={`${prefixCls}-desc`}>{$slots.desc}</div>
      </div>
    );
  }
};
